import { type FC, type ReactNode } from "react";

import { clsx } from "clsx";

export type SectionLabelTone = "default" | "muted";
export type SectionLabelSize = "sm" | "xs";

const SIZE_STYLE: Record<SectionLabelSize, string> = {
  sm: "text-xs font-medium tracking-wide",
  xs: "text-[10.5px] font-semibold tracking-[0.08em]",
};

const TONE_STYLE: Record<SectionLabelTone, string> = {
  default: "text-slate-500",
  muted: "text-slate-400",
};

export const SectionLabel: FC<{
  children: ReactNode;
  tone?: SectionLabelTone;
  size?: SectionLabelSize;
}> = ({ children, tone = "default", size = "sm" }) => (
  <span className={clsx("uppercase", SIZE_STYLE[size], TONE_STYLE[tone])}>
    {children}
  </span>
);
